import React from "react";
import Slider from "react-slick";
import "./ProductPageHeader.scss";
import carouselImage1 from '../../assets/images/banners/1752127805_cropped_image.jpg';
import carouselImage2 from '../../assets/images/banners/1752127837_cropped_image.jpg';
import carouselImage3 from '../../assets/images/banners/1752127996_cropped_image.jpg';

type ProductPageHeaderProps = {
  heading: string;
  backgroundImage: string;
};

const ProductPageHeader = ({ backgroundImage, heading}: ProductPageHeaderProps) => {


  return (
    <section className="page-header">
        <div className="page-header__bg" 
           style={{backgroundImage: `url(${backgroundImage})`}}>
        </div>
    <div className="container">
        <div className="page-header__inner">
            <h2>{heading}</h2>
            <div className="thm-breadcrumb__box">
                <ul className="thm-breadcrumb_ul list-unstyled">
                    <li><a href="https://www.eezeeinsure.com/">Home</a></li>
                    <li><span>-</span></li>
                    <li><a href="#">Insurance</a></li>
                    <li><span>-</span></li>
                    <li>{heading}</li>
                </ul>
            </div>
        </div>
    </div>
</section>
  );
};

export default ProductPageHeader;